import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitTableLine',
})
export class SplitTableLinePipe implements PipeTransform {
  transform(value: string, length: number = 15): string[] {
    const result = [];
    let tmpPosition = 0;
    let position = 0;
    let count = 1;
    while (value.indexOf(' ', position) >= 0) {
      const index = value.indexOf(' ', position);
      position = index + 1;
      if (Math.round(position / length) > count) {
        result.push(value.slice(tmpPosition, position).trim());
        tmpPosition = position;
        count++;
      }
    }

    result.push(value.slice(tmpPosition).trim());

    return result;
  }
}
